import { render, staticRenderFns } from "./clearOutstandingLogTab.vue?vue&type=template&id=6b7de948&lang=pug"
import script from "./clearOutstandingLogTab.vue?vue&type=script&lang=js"
export * from "./clearOutstandingLogTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports